import { mutationNames } from '@/store/storeKeysettings'

const state = {
  TeamMember: {
    Parent: {
      'Id': 0,
      'PageTitle': '',
      'RowCreated': null,
      'RowUpdated': null,
      'SubscriptionModuleActivation_Id': 0,
      'HeaderElements': '',
      'FooterElements': ''
    },
    'Persons': []
  }
}

const mutations = {
  [mutationNames.SET_TEAMDATA](state, TeamMember) {
    state.TeamMember = TeamMember
  },
  [mutationNames.SET_TEAMMEMBERS](state, parent) {
    state.TeamMember.Parent = parent
  },
  [mutationNames.SET_TEAMMEMBERSPERSONS](state, persons) {
    state.TeamMember.Persons = persons
  }
}

const actions = {
  initTeamData: ({commit}) => {
    commit(mutationNames.SET_TEAMDATA)
  },
  initTeamParentData: ({commit}) => {
    commit(mutationNames.SET_TEAMMEMBERS)
  },
  initTeamPersonData: ({commit}) => {
    commit(mutationNames.SET_TEAMMEMBERSPERSONS)
  }
}

const getters = {
  TeamMember: state => {
    return state.TeamMember
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/team.js